export default class InputSettings
{
  constructor(summaries, maxDays) 
  {
    this.summaries = summaries;
    this.maxDays = maxDays;
  }    
}